/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { LlmProcessRequest, LlmProcessResponse } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Llm<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * @description Sends text to LLM and returns the result as a JSON string
   *
   * @tags LLM
   * @name ProcessText
   * @summary Process text with LLM
   * @request POST:/api/admin/v1/llm/process
   */
  processText = (data: LlmProcessRequest, params: RequestParams = {}) =>
    this.request<LlmProcessResponse, any>({
      path: `/api/admin/v1/llm/process`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
